export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "upload_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click here to select a file or drag and drop them here"])},
        "accepted_types": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accepted file types: images, video, audio, documents."])},
        "errors": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Errors"])}
      },
      "fr": {
        "upload_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliquer ici pour sélectionner un fichier ou glisser et déplacer les ici"])},
        "accepted_types": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Types de fichiers acceptés : Images, video, audio et documents"])},
        "errors": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erreurs"])}
      }
    }
  })
}